@if (useNewCheckout) {
<div>
  <checkout-container></checkout-container>
</div>
} @else { @if (mainLoading$ | async) {
<div>
  <div class="loading-section">
    <div class="margin-auto">
      <app-main-loader-lottie> </app-main-loader-lottie>
    </div>
  </div>
</div>
} @else {
<div class="main_page">
  <div class="main">
    @if (migrationEnabled && !shop.metadata.useNewCheckout && !shop.metadata.enableNewAbTesting) {
    <div class="v2-abtesting-banner">
      <pdq-banner
        bannerTitle="Introducing AB Test V2: Next-Level Checkout Optimization!"
        variant="regular"
        button="Upgrade to AB test V2"
        (onButtonClick)="upgradeToV2AbTesting()"
        [closable]="false"
        variantButton="transparent-info">
        <br />
        <span>
          AB test V2 empowers you to fine-tune your checkout process for maximum conversion. Upgrade now to start
          leveraging the full power of AB testing.
        </span>
      </pdq-banner>
    </div>
    } @if (!(isShoppingBannerClosed$ | async)) {
    <div class="shopping-banner">
      @if (shop?.platform === 'shopify') {
      <pdq-banner
        [bannerTitle]="'Set up Google Shopping delivery'"
        variant="attention"
        (onDestroy)="onShoppingBannerClose()">
        <br />
        Using Google Shopping? Enable PDQ rates in checkout by
        <pdq-link
          [external]="true"
          url="https://support.prettydamnquick.com/en/articles/6183367-setting-up-delivery-methods-for-google-shopping"
          label="following this guide"></pdq-link>
      </pdq-banner>
      }
    </div>
    } @if (!(isABTestBannerClosed$ | async) && (abTestWarning$ | async) && (settings$ | async).runTestVariantsTogether)
    {
    <div class="ab-test-banner">
      <pdq-banner
        bannerTitle="Notice: A/B Tests are not running due to enabled general settings"
        variant="attention"
        (onDestroy)="onABTestBannerClose()">
        <br />
        <span>
          One or more of your checkout methods doesn't have the A/B test enabled, so the B variant of that method isn't
          presented at checkout (working as its supposed to) you can either change it in the
          <pdq-link class="inline" (onClick)="navigateToCheckoutSettings()" label="general settings"></pdq-link> or
          enable the B variant on the other checkouts</span
        >
      </pdq-banner>
    </div>
    }
    <div class="main__header">
      <h1>Your checkout's delivery methods</h1>

      <pdq-button label="+ Add delivery method" icon="add_button" variant="tertiary" (onClick)="newShipping()">
      </pdq-button>
    </div>
    <span class="main__header__subtitle">Manage which shipping options show in checkout</span>
    <div class="main__content">
      <div class="table-header">
        @for (column of columnsConfig; track column) {
        <div [ngClass]="{ 'col-20': column.prop !== 'actions' }">{{ column.name}}</div>
        }
      </div>
      @if (shop?.platform === 'shopify') {
      <fallback-option
        [loadedFallbackMethod]="(loadFallbackMethod$ | async) && (loadFallbackMethod$ | async)[0]"
        [shop]="shop$ | async">
      </fallback-option>
      } @for (checkout of loadCheckouts$ | async; track checkout) {
      <div class="list">
        <div class="col-25">
          <pdq-tag variant="quaternary" mode="rect">{{ checkout.shippingMethod.category | displayCategory }}</pdq-tag>
          @if (checkout.isTestMode) {
          <pdq-tag variant="quaternary" mode="rect">Test mode</pdq-tag>
          } @if (checkout.runningTest) {
          <pdq-tag variant="quaternary" mode="rect">A/B test</pdq-tag>
          }
          <div style="color: var(--on-surface-light)">{{ checkout.internalName || '-' }}</div>
        </div>
        <div class="col-25">
          <div class="bold">{{ checkout.name || '-' }}</div>
          <div>{{ checkout.notes }}</div>
        </div>
        <div class="col-25">
          <display-conditions
            [conditions]="checkout.conditions | filterLocationCondition"
            [currency]="(checkout.methodCurrency | currencySign) || currency">
          </display-conditions>
          <display-delivery-promise [shipping]="checkout"> </display-delivery-promise>
          <display-geo-settings [shipping]="checkout"> </display-geo-settings>
          <display-delivery-time [shipping]="checkout"> </display-delivery-time>
        </div>
        <div class="col-10">
          <display-rate-prices [shipping]="checkout" [currency]="(checkout.methodCurrency | currencySign) || currency">
          </display-rate-prices>
        </div>
        <div class="actions">
          <pdq-slide-toggle
            class="toggle"
            [defaultValue]="!!checkout.enabled"
            [disabled]="!!disableEnableBtnMap[+checkout.id]"
            (click)="$event.stopPropagation()"
            (onToggle)="onModeChange($event, checkout.id);">
          </pdq-slide-toggle>
          <pdq-dropdown
            [ngStyle]="{ margin: 'auto' }"
            [type]="'button'"
            [options]="actionOptions | displayPreviewRunningABTestOnlyIfExists : checkout?.runningTest"
            [clearSelectionOption]="true"
            mode="ghost"
            icon="dots_menu"
            align="right"
            (onChange)="onAction($event, checkout)">
          </pdq-dropdown>
        </div>
      </div>
      }
    </div>
  </div>
</div>
} }
